/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAirIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-air"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11.38 20.85Q10.47 20.85 9.68 20.44Q8.88 20.02 8.38 19.3Q7.9 18.65 8.26 17.93Q8.63 17.2 9.43 17.2Q9.78 17.2 10.07 17.39Q10.38 17.57 10.63 17.82Q10.78 17.98 10.96 18.09Q11.15 18.2 11.38 18.2Q11.72 18.2 11.96 17.96Q12.2 17.73 12.2 17.38Q12.2 17.02 11.96 16.79Q11.72 16.55 11.38 16.55L2.83 16.55Q2.27 16.55 1.89 16.16Q1.5 15.78 1.5 15.22Q1.5 14.68 1.89 14.29Q2.27 13.9 2.83 13.9L11.38 13.9Q12.82 13.9 13.84 14.91Q14.85 15.93 14.85 17.38Q14.85 18.82 13.84 19.84Q12.82 20.85 11.38 20.85ZM2.83 10.05Q2.27 10.05 1.89 9.66Q1.5 9.28 1.5 8.72Q1.5 8.18 1.89 7.79Q2.27 7.4 2.83 7.4L15.47 7.4Q16.02 7.4 16.41 7.01Q16.8 6.63 16.8 6.08Q16.8 5.53 16.41 5.14Q16.02 4.75 15.47 4.75Q15.13 4.75 14.79 4.91Q14.45 5.08 14.25 5.38Q13.97 5.72 13.61 5.99Q13.25 6.25 12.82 6.25Q12.1 6.25 11.76 5.61Q11.43 4.97 11.78 4.3Q12.3 3.25 13.3 2.67Q14.3 2.1 15.47 2.1Q17.13 2.1 18.29 3.26Q19.45 4.42 19.45 6.08Q19.45 7.72 18.29 8.89Q17.13 10.05 15.47 10.05ZM20.7 18.02Q19.98 18.45 19.25 18.1Q18.52 17.75 18.52 16.95Q18.52 16.57 18.75 16.26Q18.98 15.95 19.3 15.75Q19.57 15.55 19.71 15.26Q19.85 14.97 19.85 14.63Q19.85 14.07 19.46 13.69Q19.07 13.3 18.52 13.3L2.83 13.3Q2.27 13.3 1.89 12.91Q1.5 12.53 1.5 11.97Q1.5 11.43 1.89 11.04Q2.27 10.65 2.83 10.65L18.52 10.65Q20.18 10.65 21.34 11.81Q22.5 12.97 22.5 14.63Q22.5 15.68 22.04 16.59Q21.57 17.5 20.7 18.02Z" fill={color} />
    </svg>
  );
}
